import * as React from "react";
import {SFC} from "react";
import {StringRadioButtonGroup} from "components/form/RadioButton/RadioButtonGroup";
import RadioButton from "components/form/RadioButton/RadioButton";
import {ScriptingLanguage} from "components/scriptingLanguage";

interface ScriptingLanguageSelectorProps {
    value: ScriptingLanguage;
    onChange: (value: ScriptingLanguage) => void;
    onlyRunnableOnServer?: boolean;
    autoFocus?: boolean;
    doNotAutoFocus?: boolean;
}

const ScriptingLanguageSelector: SFC<ScriptingLanguageSelectorProps> = (props: ScriptingLanguageSelectorProps) => {
    return  <StringRadioButtonGroup
                horizontal={true}
                value={props.value}
                autoFocus={props.autoFocus}
                onChange={props.onChange}>
                {[<RadioButton value={ScriptingLanguage.PowerShell} label="PowerShell" key={ScriptingLanguage.PowerShell}/>,
                  <RadioButton value={ScriptingLanguage.CSharp} label="C#" key={ScriptingLanguage.CSharp}/>,
                  !props.onlyRunnableOnServer && <RadioButton value={ScriptingLanguage.Bash} label="Bash" key={ScriptingLanguage.Bash}/>,
                 <RadioButton value={ScriptingLanguage.FSharp} label="F#" key={ScriptingLanguage.FSharp} />].filter(option => !!option)}
    </StringRadioButtonGroup>;
};

ScriptingLanguageSelector.displayName = "ScriptingLanguageSelector";

ScriptingLanguageSelector.defaultProps = {
    doNotAutoFocus: true
};

export default ScriptingLanguageSelector;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/ScriptingLanguageSelector/ScriptingLanguageSelector.tsx